import { unwrap } from '../http.js';
export function createReportsApi(client) {
    return {
        async create(body) {
            return unwrap(await client.POST('/v1/reports', { body }));
        },
    };
}
//# sourceMappingURL=reports.js.map